import { Suspense } from 'react';
import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import { AddOrgDialogContent } from './AddOrgDialog';
import { AddOrgDialogSkeleton } from './AddOrgDialogSkeleton';

export function useAddOrgDialog() {
  const showModal = useModal();
  return (supplyPointId: number, alreadyAddedPartnerIds: number[]) =>
    showModal<void>({
      content: ({ resolve }) => (
        <Suspense fallback={<AddOrgDialogSkeleton />}>
          <AddOrgDialogContent
            supplyPointId={supplyPointId}
            alreadyAddedPartnerIds={alreadyAddedPartnerIds}
            resolve={resolve}
          />
        </Suspense>
      ),
    });
}
